import React from 'react'

const CompletedIcon = () => {
    return (
        <div className="success-circle">
            <svg width="30px" height="30px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <g>
                    <path d="M20,0 C8.955,0 0,8.955 0,20 C0,31.045 8.955,40 20,40 C31.045,40 40,31.045 40,20 C40,8.955 31.045,0 20,0" fill="#409C01"></path>
                    <path d="M28.9636902,12.8116414 L17.677351,23.2918136 L12.0341814,17.6486439 C11.651252,17.2334679 10.4218472,16.0363098 8.80951305,17.6486439 C7.19717887,19.2609781 8.42658368,20.4581362 8.80951305,20.8733123 L17.677351,29.7411503 L32.1883586,16.0363098 C32.5793496,15.6433033 33.8006928,14.4239756 32.1883586,12.8116414 C30.5760244,11.1993072 29.3566967,12.4206504 28.9636902,12.8116414 Z" fill="#FFFFFF"></path>
                </g>
            </svg>
        </div>
    )
}

export default CompletedIcon


// WEBPACK FOOTER //
// ./src/components/icons/CompletedIcon.js